import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import LandingMediaKitProposal from '../TNOMediaKitProposal';

const mercosurTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#f57c00',
      light: '#ff9800',
      dark: '#e65100',
    },
  },
});

const LandingMediaKitMercosur = (props) => (
  <ThemeProvider theme={mercosurTheme}>
    <LandingMediaKitProposal {...props} staticOnly forcedSlug="mercosur" />
  </ThemeProvider>
);

export default LandingMediaKitMercosur;
